import type { IconDefinition } from '../index.tsx';

export const iconArrowDownLeft: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconArrowDownLeft',
  icon: [
    16,
    16,
    [],
    '',
    'M10.1872 14.5447L7.27657 11.6341L16 3.05786L13.0893 0.147229L4.36594 8.72343L1.45531 5.81281L7.63365e-07 7.26812L2.86102e-06 16L8.73188 16L10.1872 14.5447Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
